import { Analytics } from "cookiesConsent/domain/analytics"
import { latestConsent } from "cookiesConsent/features/getConsent/latestConsent"
import { ConsentGatedAnalytics } from "cookiesConsent/domain/ConsentGatedAnalytics"
import { DeduplicatedGuestAnalytics } from "cookiesConsent/domain/DeduplicatedGuestAnalytics"
import { SegmentAnalytics } from "cookiesConsent/infrastructure/segment/SegmentAnalytics"

// Built on first use, so one page shares one Analytics: a Guest is
// identified once per email per page.
let pageAnalytics: Analytics | undefined

export const analyticsForThisPage = (): Analytics => {
  pageAnalytics =
    pageAnalytics ??
    new ConsentGatedAnalytics(
      new DeduplicatedGuestAnalytics(new SegmentAnalytics()),
      latestConsent
    )
  return pageAnalytics
}
